import TranscriptSettings from './transcript-settings';
import VideosPage from './VideosPage';
import VideoThumbnail from './VideoThumbnail';
import VideoInfoModalSidebar from './info-sidebar';

export default VideosPage;
export { TranscriptSettings, VideoThumbnail, VideoInfoModalSidebar };
